import { render, staticRenderFns } from "./noTice.vue?vue&type=template&id=d0309d2e&"
import script from "./noTice.vue?vue&type=script&lang=js&"
export * from "./noTice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports